export const examsData = [
  {
    title: 'Consultation de cardiologie',
    subTitle:
      'Évaluation, diagnostic et suivi personnalisé de votre santé cardiovasculaire.',
    iconUrl: '/images/home_1/exam_consultation.svg',
  },
  {
    title: 'Électrocardiogramme (ECG)',
    subTitle:
      'Enregistrement de l’activité électrique du cœur en quelques minutes.',
    iconUrl: '/images/home_1/exam_ecg.svg',
  },
  {
    title: 'Échographie cardiaque',
    subTitle:
      'Imagerie non invasive pour évaluer la structure et le fonctionnement du cœur.',
    iconUrl: '/images/home_1/exam_echo.svg',
  },
  {
    title: 'Holter ECG 24h / 48h',
    subTitle:
      'Surveillance continue du rythme cardiaque pendant 24 à 48 heures.',
    iconUrl: '/images/home_1/exam_holter_ecg.svg',
  },
  {
    title: 'Holter tensionnel (MAPA)',
    subTitle: 'Mesure de la tension artérielle pendant 24 heures.',
    iconUrl: '/images/home_1/exam_mapa.svg',
  },
  {
    title: 'Test d’effort',
    subTitle:
      'Évaluation du fonctionnement du cœur à l’effort sous surveillance médicale.',
    iconUrl: '/images/home_1/exam_effort.svg',
  },
];
